"use strict"

module.exports = convexHull1d

function convexHull1d(points) {
  var lo = 0
  var hi = 0
  for(var i=1; i<points.length; ++i) {
    if(points[i][0] < points[lo][0]) {
      lo = i
    }
    if(points[i][0] > points[hi][0]) {
      hi = i
    }
  }
  if(lo < hi) {
    return [[lo], [hi]]
  } else if(lo > hi) {
    return [[hi], [lo]]
  } else {
    return [[lo]]
  }
}


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/convex-hull/lib/ch1d.js
// module id = ../../../../convex-hull/lib/ch1d.js
// module chunks = vendor